'use client'

import { Toaster as SonnerToaster } from '@/components/ui/sonner'

export function Toaster() {
  return <SonnerToaster />
}
